// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"5e63bcea","533":"43aa1b78"}[chunkId] + ".chunk.css";
};